import React from "react";
// javascript library that creates a parrallax effect
import Rellax from "rellax";
// reactstrap components
import { Container } from "reactstrap";
// core components

// sections for this page
import PresentationHeader from "components/Headers/PresentationHeader2.js";
// import Politica from "./Notario/Notario.js";


function Ninos() {
  React.useEffect(() => {
    document.body.classList.add("presentation-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    // initialise Rellax for this page
    if (window.innerWidth >= 991) {
      setTimeout(function () {
        new Rellax(".rellax", {
          center: true,
        });
      }, 5000);
      new Rellax(".rellax-header");
      new Rellax(".rellax-text");
    }

    // we need to add a script for the github buttons
    let script = document.createElement("script");
    script.src = "https://buttons.github.io/buttons.js";
    script.id = "github-buttons-script-id";
    document.body.appendChild(script);

    return function cleanup() {
      document.body.classList.remove("tramites-page");
      document.body.classList.remove("sidebar-collapse");

      // we need to remove the script when we change the page
      script.parentNode.removeChild(script);
    };
  });
  return (
    <>
      <div className="wrapper">
        <PresentationHeader titulo="Organigrama"/>
        <div id= "servicio" style={{backgroundColor: "#f9f9f9"}}>
          <Container className="fluid">
            <h3 className="title text-center" style={{color:"#2c2c2c"}} id="exampleModalLiveLabel">
              Organigrama
            </h3>
            <img
              alt="Organigrama de la notaria, comenzando por el notario y terminando por el area legal y recursos humanos"
              width="100%"
              src={require("assets/img/Notaria/organigrama.png")}
            ></img>
            <br/>
            <center>
              <a  type="button" href={"https://drive.google.com/file/d/1_M2fPSh1JY7SpFPMDYTVaJoaffeQCbp7/view?usp=sharing"} style={{borderBottom: "none"}} target="_black">
                <img
                  alt="Imagen con referencia Organigrama"
                  width="80px"
                  src={require("assets/img/Notaria/PDF.png")}
                ></img>
                <h6  className="texto">Estructura Orgánica</h6>
              </a>
            </center>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Ninos;